import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import SearchAppBar from "../../components/common/search";
import { useNavigate } from "react-router-dom";
import ViewData from "../../components/grids/ViewDatagrid";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import AddLocationAltOutlinedIcon from "@mui/icons-material/AddLocationAltOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import DocumentScannerOutlinedIcon from "@mui/icons-material/DocumentScannerOutlined";
import SipOutlinedIcon from "@mui/icons-material/SipOutlined";
import { userdata } from "../../assets/Griddata"; // Import dataset
import { externalgetApi } from "../../services/external/externalApis";
import { USERS_COMPANY_USERS_API } from "../../api/ApiModel";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
function ViewUsers() {
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [filteredData, setFilteredData] = useState(null);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  // Get user parameters from Redux store
  //done 12
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, USERREFCODE, EXPDATE, STS } = SYS_USER.USER_PARAM || {};

  const goToPage = () => {
    navigate("/AddUsers");
  };

  const goToMapLocation = (userRefCode, locCode, username) => {
    navigate("/MapLocations", { state: { userRefCode, locCode, username } });
  };

  const goToUpdateAccount = (userRefCode, username) => {
    navigate("/UpdateAccount", { state: { userRefCode, username } });
  };

  const goToUpdateSession = (userRefCode, username) => {
    navigate("/UpdateSession", { state: { userRefCode, username } });
  };

  const goToViewUserLogs = (userRefCode, username) => {
    navigate("/ViewUserLogs", { state: { userRefCode, username } });
  };

  useEffect(() => {
    if (data) {
      const filtered = data.filter((item) =>
        item.GROUPNAME.toLowerCase().includes(searchText.toLowerCase()) ||   item.USERNAME.toLowerCase().includes(searchText.toLowerCase())
      );
      setFilteredData(filtered);
    }
  }, [searchText, data]);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value); // Update searchText when typing in TextField
  };

  const handleItemClick = (id, actionText) => {
    const selectedItem = data.find((item) => item.USERREFCODE === id);

    if (selectedItem?.GROUPNAME === "Guest Admin Account") {
      setSnackbarMessage(
        "You can't edit or change the default user account details.. !"
      );
      setSnackbarOpen(true);
    } else if (actionText === "Edit" && selectedItem) {
      navigate(`/AddUsers`, { state: { selectedItem, actionText } });
    } else {
      navigate(`/AddUsers`, { state: { selectedItem: "" } });
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      onClick: (USERREFCODE) => handleItemClick(USERREFCODE, "Edit"),
    },
    {
      text: "Map Locations",
      icon: <AddLocationAltOutlinedIcon />,
      onClick: (USERREFCODE) => {
        const selectedUser = data.find(
          (user) => user.USERREFCODE === USERREFCODE
        );
        if (selectedUser) {
          goToMapLocation(
            USERREFCODE,
            selectedUser.LOCCODE,
            selectedUser.USERNAME
          ); // Pass both userRefCode and locCode
        }
      },
    },

    {
      text: "Update Account",
      icon: <ManageAccountsOutlinedIcon />,
      // onClick: goToUpdateAccount,
      onClick: (USERREFCODE) => {
        const selectedUser = data.find(
          (user) => user.USERREFCODE === USERREFCODE
        );
        if (selectedUser) {
          goToUpdateAccount(
            USERREFCODE,

            selectedUser.USERNAME
          ); // Pass both userRefCode and locCode
        }
      },
    },
    {
      text: "Update Session",
      icon: <SipOutlinedIcon />,

      onClick: (USERREFCODE) => {
        const selectedUser = data.find(
          (user) => user.USERREFCODE === USERREFCODE
        );
        if (selectedUser) {
          goToUpdateSession(USERREFCODE, selectedUser.USERNAME); // Pass both userRefCode and locCode
        }
      },
    },
    {
      text: "View User Log",
      icon: <DocumentScannerOutlinedIcon />,
      // onClick: goToViewUserLogs,
      onClick: (USERREFCODE) => {
        const selectedUser = data.find(
          (user) => user.USERREFCODE === USERREFCODE
        );
        if (selectedUser) {
          goToViewUserLogs(USERREFCODE, selectedUser.USERNAME); // Pass both userRefCode and locCode
        }
      },
    },
  ];

  const rows = filteredData
    ? filteredData.map((item, index) => ({
        id: index + 1,
        USERREFCODE: item.USERREFCODE,
        USERNAME: item.USERNAME,
        GROUPNAME: item.GROUPNAME,
        STS: item.STS,
        LOCCODE: item.LOCCODE,
      }))
    : [];

  // API calls start
  //done 12
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(USERS_COMPANY_USERS_API, "get", {
          COMPCODE: COMPCODE,
          STS: CON_STATUS_ACTIVE,
        });

        setData(result);
        setFilteredData(result);
        console.log("hh", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Users</Link>
                <Link underline="none">View Users</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
              >
                <SearchAppBar
                  onChange={handleSearchChange}
                  value={searchText}
                  id="search"
                />
                <Button
                  onClick={goToPage}
                  variant="contained"
                  size="medium"
                  startIcon={<AddCircleIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    width: "80px",
                  }}
                  id="btnadd"
                >
                  Add
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <ViewData
          columns={userdata.columns}
          rows={rows}
          menuItems={menuItems}
          tabletitle={userdata.name}
          gridid="USERREFCODE"
        />
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="warning"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default ViewUsers;
